import React, { useEffect, useState } from "react";

import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import LockIcon from "@mui/icons-material/Lock";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import { Button, FormHelperText, Stack } from "@mui/material";

import { Loader } from "../../common/loader";
import { ROLES } from "../../helpers/constants";
import AlertDialog from "../../common/AlertDialog";
import StatusModal from "../../common/customDesignedComponents/StatusModal";
import HubspotCookieBreakerInput from "../../common/HubspotCookieBreakerInput";
import OwnershipVerificationModal from "../../common/OwnershipVerificationModal";
import { propertiesAction } from "../../../redux/slices/properties/propertiesSlice";
import CustomizedCheckbox from "../../common/customDesignedComponents/customCheckbox";
import SecurityInfoV2 from "../../user-signup/SignupTaiwindComponents/SecurityInfoV2";
import { clearEpAwareSignupArtifactsOnSkip } from "../../helpers/epAwareVerificationGuard";
import {
  decryptPayload,
  getObjLength,
  numberToWords,
  user_signup_details,
} from "../../helpers/utils";
import { mapCreateUserApiUrl } from "../../for-service-provider/createUserApiPaths";
import { userSigupAction } from "../../../redux/slices/user/userSignUpSlice";

const initialValues = {
  houseInfo_1: "",
  houseInfo_2: "",
  houseInfo_3: "",
};

const validationSchema3 = Yup.object().shape({
  houseInfo_1: Yup.string().required(
    "Please select an option to proceed further.",
  ),
  houseInfo_2: Yup.string().required(
    "Please select an option to proceed further.",
  ),
  houseInfo_3: Yup.string().required(
    "Please select an option to proceed further.",
  ),
});

const validationSchema2 = Yup.object().shape({
  houseInfo_1: Yup.string().required(
    "Please select an option to proceed further.",
  ),
  houseInfo_2: Yup.string().required(
    "Please select an option to proceed further.",
  ),
});

const validationSchema1 = Yup.object().shape({
  houseInfo_1: Yup.string().required(
    "Please select an option to proceed further.",
  ),
});

const SecurityInfoScreen = ({
  values,
  setFieldValue,
  touched,
  errors,
  onBtnClick,
  setAnswers,
  onChangeModalScreen,
  onCloseModalHandler,
  isSubscriptionScreenRequired,
  isByPassOptionAvailable,
  isAdminCreateUser = false,
  isQuestionByPass = false,
  backToSearchProperty,
  editProperty = false,
  isShow = true,
  //old property data
  oldPropertyData = {},
  setSkipVerification,
  onSkipVerificationPopupChange,
  handleCloseAddPropertyModal,
  user_id = null,
  promoCode = undefined,
  selectedRowData = {},
  isUpgradeCategory = false,
  userEmail = undefined,
  isTailwindComponent = false,
  isServiceProvider = false,
  ownershipVerifiedViaId = false,
  ownershipVerificationAlreadyComplete = false,
  continueUserId = null,
  epAwareSessionId = null,
  category = "complete_protection",
  skipVerification = false,
}) => {
  const [checked1, setChecked1] = useState(false);
  const [checkTerms, setCheckTerms] = useState(true);
  const [agreeToOwnership, setAgreeToOwnership] = useState(true);
  const [isResponseModalOpen, setIsResponseModalOpen] = useState(false);
  const [verifiedCount, setVerifiedCount] = useState(1);
  const [skipVerificationPopup, setSkipVerificationPopup] = useState(false);
  const updateSkipVerificationPopup = (open) => {
    setSkipVerificationPopup(open);
    onSkipVerificationPopupChange?.(open);
  };
  const [ownershipVerificationModal, setOwnershipVerificationModal] =
    useState(false);
  const [addPropertyIntroNote, setAddPropertyIntroNote] = useState("");

  const role = decryptPayload(localStorage.getItem("roles"));
  const user_data = user_signup_details() || selectedRowData;

  const getPropertyData = useSelector(
    (state) => state.properties.selectedProperty,
  );

  const propertyQuestion = useSelector(
    (state) => state?.properties?.propertyQuestion,
  );

  const { data: userData } = useSelector(
    (state) => state?.userProfile?.userProfileDetails,
  );
  const {
    propertyVerified,
    selectedUserID,
    verificationLoader,
    genearteQuesPayload,
    userPropertyData,
  } = useSelector((state) => state?.properties);
  const accCreated = useSelector((state) => state.signUpUser.createAccResponse);
  const skipVerifyAnswersResponse = useSelector(
    (state) => state.signUpUser.skipVerifyAnswers,
  );
  const { ownerShipLoader, setDefaultOwnerNameDetails, signupLoader } =
    useSelector((state) => state.signUpUser);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isTailwindComponent) {
      return;
    }

    const noMailingMatch = sessionStorage.getItem("addPropertyMailingNoMatch");
    if (noMailingMatch === "1") {
      setAddPropertyIntroNote(
        "We didn't find other properties in your county that match your ID mailing address, so challenge questions are required for this new address.",
      );
      sessionStorage.removeItem("addPropertyMailingNoMatch");
    }
  }, [isTailwindComponent]);

  console.log("oldPropertyData ==>", oldPropertyData);

  const resolveClientUserId = () =>
    Number(continueUserId) ||
    selectedUserID ||
    (isAdminCreateUser && getObjLength(accCreated)
      ? accCreated?.data?.user_id
      : null) ||
    user_id ||
    userData?.user_id;

  const questions =
    propertyQuestion?.data !== undefined &&
    propertyQuestion?.data &&
    Object.values(
      propertyQuestion?.success && !propertyQuestion?.data?.is_verified
        ? propertyQuestion?.data?.questions || {}
        : {},
    );

  const isThirdPartyOwnerAttestation =
    (isAdminCreateUser || isServiceProvider) &&
    (ownershipVerifiedViaId === true ||
      propertyQuestion?.data?.is_verified === true ||
      (propertyQuestion?.success &&
        (!questions?.length || questions.length === 0)));

  const emptyValidationSchema = Yup.object({});
  const activeValidationSchema =
    isThirdPartyOwnerAttestation || !questions?.length
      ? emptyValidationSchema
      : questions?.length > 2
        ? validationSchema3
        : questions?.length > 1
          ? validationSchema2
          : validationSchema1;

  const buildAddPropertyVerifyPayload = () => {
    const propertyData =
      getPropertyData?.json_response || getPropertyData?.json_res || {};
    const resolvedUserId = resolveClientUserId();

    const payload = {
      property_id: getPropertyData?.property_id,
      state_code: propertyData?.mm_fips_state_code,
      user_id: resolvedUserId,
      answers: { ep_aware: "verified" },
      step: 2,
      step_key: "VERIFY_VIA_EPAWARE",
      ...genearteQuesPayload,
      ...(epAwareSessionId
        ? {
            ep_aware_verified: true,
            ep_aware_session_id: epAwareSessionId,
          }
        : {}),
    };

    if (
      getObjLength(userPropertyData) &&
      userPropertyData?.data?.type === "parcel"
    ) {
      return { ...payload, ...userPropertyData?.data };
    }

    return payload;
  };

  const onSubmit = (values, errors) => {
    setCheckTerms(checked1);

    const key1 = Object.values(propertyQuestion?.data?.questions || {})[0]
      ?.question_code;
    const key2 = Object.values(propertyQuestion?.data?.questions || {})[1]
      ?.question_code;
    const key3 = Object.values(propertyQuestion?.data?.questions || {})[2]
      ?.question_code;

    let answer = {};
    if (key1) {
      answer[key1] = values?.houseInfo_1;
    }
    if (
      Object.values(propertyQuestion?.data?.questions || {})[1]?.question_code
    ) {
      answer[key2] = values?.houseInfo_2;
    }
    if (
      Object.values(propertyQuestion?.data?.questions || {})[2]?.question_code
    ) {
      answer[key3] = values?.houseInfo_3;
    }
    var selectedData = {};
    if (Object.keys(getPropertyData).length > 0) {
      console.log("getPropertyData==> 1", getPropertyData);
      let propertyData = getPropertyData?.json_response;
      selectedData = {
        property_id: getPropertyData?.property_id,
        state_code: propertyData?.mm_fips_state_code,
        user_id: resolveClientUserId(),
        answers: answer,
      };
      if (
        getObjLength(userPropertyData) &&
        userPropertyData?.data?.type === "parcel"
      ) {
        selectedData = { ...selectedData, ...userPropertyData?.data };
      }
      console.log("answers object==>", selectedData);
    }
    if (getPropertyData?.from_resume) {
      selectedData = {
        ...selectedData,
        from_resume: getPropertyData?.from_resume,
      };
    }

    if (isThirdPartyOwnerAttestation) {
      if (!checked1 || !agreeToOwnership) {
        setCheckTerms(checked1 && agreeToOwnership);
        return;
      }

      if (ownershipVerificationAlreadyComplete) {
        onChangeModalScreen(
          isAdminCreateUser ? "propertyList" : "subscriptions",
        );
        return;
      }

      if (isByPassOptionAvailable) {
        dispatch(propertiesAction.setVerificationLoader(true));
        dispatch(
          propertiesAction.verifyAnswers({
            url: mapCreateUserApiUrl(
              "admin/properties/verify-answers",
              isServiceProvider,
            ),
            data: {
              ...buildAddPropertyVerifyPayload(),
              user_id: resolveClientUserId(),
              promoCode: promoCode,
            },
            token: true,
          }),
        );
      } else {
        setAnswers(buildAddPropertyVerifyPayload());
        onChangeModalScreen(
          isAdminCreateUser ? "propertyList" : "subscriptions",
        );
      }
      return;
    }

    if (checked1 || isTailwindComponent) {
      if (isByPassOptionAvailable) {
        dispatch(propertiesAction.setVerificationLoader(true));
        console.log("edit ptoperty", editProperty);
        if (editProperty) {
          dispatch(
            propertiesAction.verifyAnswers({
              url: mapCreateUserApiUrl(
                "admin/property/verify-answers",
                isServiceProvider,
              ),
              data: {
                ...selectedData,
                prop_id: oldPropertyData?.id,
                old_address: oldPropertyData?.address,
                old_property_id: oldPropertyData?.property_id,
                step: 2,
                step_key: "VERIFY_ANSWERS",
                ...genearteQuesPayload,
              },
              token: true,
            }),
          );
        } else {
          console.log(genearteQuesPayload, "selectedData==>", selectedData);

          dispatch(
            propertiesAction.verifyAnswers({
              url: mapCreateUserApiUrl(
                "admin/properties/verify-answers",
                isServiceProvider,
              ),
              data: {
                ...selectedData,
                user_id: selectedData?.user_id || user_id,
                step: 2,
                step_key: "VERIFY_ANSWERS",
                ...genearteQuesPayload,
                promoCode: promoCode,
              },
              token: true,
            }),
          );
        }
      } else {
        setAnswers(selectedData);
        onChangeModalScreen(
          isAdminCreateUser ? "propertyList" : "subscriptions",
        );
      }
      // handleToggle();
      // dispatch(
      //   propertiesAction.verifyAnswers({
      //     url: "properties/verify-answers",
      //     data: selectedData,
      //     token: true,
      //   })
      // );
    }

    // if (Object.keys(fromErr).length === 0) {
    // onBtnClick();
    // }
  };

  const onClickSubmit = (err) => {
    console.log("inner error==>", err);
    // setFormErr(err);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const onChecked = (e) => {
    console.log("cjceked val==?", e.target.checked);
    setChecked1(e.target.checked);
    if (!e.target.checked) {
      setCheckTerms(e.target.checked);
    } else {
      setCheckTerms(true);
    }
  };

  // handle modal open
  const handleResponseModalOpen = () => {
    setIsResponseModalOpen(true);
  };

  // handle modal close
  const handleResponseModalClose = () => {
    if (editProperty) {
      if (oldPropertyData?.subscription?.is_active) {
        onCloseModalHandler("success");
      } else {
        dispatch(propertiesAction.setGeneratedQuestionsData({}));
        if (isAdminCreateUser) {
          navigateToAdminPropertyList();
        } else {
          onChangeModalScreen("subscriptions");
        }
      }
    } else {
      dispatch(propertiesAction.setGeneratedQuestionsData({}));
      if (isAdminCreateUser) {
        navigateToAdminPropertyList();
      } else {
        onChangeModalScreen("subscriptions");
      }
    }
    setIsResponseModalOpen(false);
  };

  const goToOwnerVerification = () => {
    handleResponseModalClose();
    setOwnershipVerificationModal(false);
  };

  const openOwnershipVerificationModal = () => {
    setIsResponseModalOpen(false);
    updateSkipVerificationPopup(false);
    setOwnershipVerificationModal(true);
  };

  const hasSetupOwnerName =
    getObjLength(user_data) &&
    (user_data?.first_owner_first_name?.length > 0 ||
      user_data?.first_trust_llc_name?.length > 0);

  const handleVerifiedSuccessModalClose = () => {
    if (hasSetupOwnerName) {
      openOwnershipVerificationModal();
      return;
    }
    handleResponseModalClose();
  };

  const buildSkipVerifyPayload = () => {
    const propertyData =
      getPropertyData?.json_response || getPropertyData?.json_res || {};
    const payload = {
      user_id: resolveClientUserId(),
      step: 2,
      step_key: "SKIP_VERIFY_ANSWERS",
      property_id: getPropertyData?.property_id,
      state_code: propertyData?.mm_fips_state_code,
      ...(getObjLength(genearteQuesPayload) ? genearteQuesPayload : {}),
    };

    if (
      getObjLength(userPropertyData) &&
      userPropertyData?.data?.type === "parcel"
    ) {
      return { ...payload, ...userPropertyData.data };
    }

    return payload;
  };

  const refreshAdminPropertyList = () => {
    if (!isAdminCreateUser) {
      return;
    }

    const listUserId = resolveClientUserId();
    if (!listUserId) {
      return;
    }

    dispatch(
      userSigupAction.getPropertiesList({
        url: mapCreateUserApiUrl("admin/properties/list", isServiceProvider),
        token: true,
        data: { user_id: listUserId },
      }),
    );
  };

  const navigateToAdminPropertyList = () => {
    dispatch(userSigupAction.clearPropertyVerified({}));
    refreshAdminPropertyList();
    onChangeModalScreen("propertyList");
  };

  const completeSkipVerificationFlow = () => {
    dispatch(propertiesAction.setGeneratedQuestionsData({}));
    dispatch(userSigupAction.clearSkipVerifyAnswers({}));

    if (
      getObjLength(user_data) &&
      (user_data?.first_owner_first_name?.length > 0 ||
        user_data?.first_trust_llc_name?.length > 0)
    ) {
      setOwnershipVerificationModal(true);
      return;
    }

    if (isAdminCreateUser) {
      navigateToAdminPropertyList();
      return;
    }

    onChangeModalScreen("subscriptions");
  };

  // Skip property verification — persist the property before leaving questions.
  const skipQuestionAnswers = () => {
    clearEpAwareSignupArtifactsOnSkip();
    const payload = buildSkipVerifyPayload();

    if (!payload.property_id || !payload.user_id) {
      return;
    }

    setSkipVerification?.(true);
    setAnswers({
      property_id: payload.property_id,
      state_code: payload.state_code,
      user_id: payload.user_id,
    });
    updateSkipVerificationPopup(false);
    dispatch(
      userSigupAction.skipVerifyAnswers({
        url: `properties/skip-verify-answers?property_id=${payload.property_id}`,
        data: payload,
        token: true,
      }),
    );
  };

  const addPropertyEpAwareContext = {
    userId:
      (isAdminCreateUser && getObjLength(accCreated)
        ? accCreated?.data?.user_id
        : userData?.user_id || user_id) ?? "",
    propertyId: getPropertyData?.property_id,
    propertyAddress: getPropertyData || propertyQuestion?.data || {},
    partyEmail: userEmail || userData?.email,
    partyPhone: userData?.phone || userData?.phone1,
    partyName: userData?.first_name
      ? `${userData.first_name} ${userData.last_name || ""}`.trim()
      : undefined,
  };

  const handleAddPropertyIdVerified = (response) => {
    dispatch(propertiesAction.setVerifedAnswersData(response));
    setAnswers({
      ...buildAddPropertyVerifyPayload(),
      ep_aware_verified: true,
    });
    if (propertyQuestion?.data) {
      dispatch(
        propertiesAction.setGeneratedQuestionsData({
          ...propertyQuestion,
          data: {
            ...propertyQuestion.data,
            is_verified: true,
            owner_verified: true,
          },
        }),
      );
    }
    if (isAdminCreateUser) {
      navigateToAdminPropertyList();
    } else {
      onChangeModalScreen("subscriptions");
    }
  };

  // to prevent closing modal until verified answers
  // useEffect(() => {
  //   if (propertyVerified?.success === true) {
  //     onCloseModalHandler();
  //   }
  //   handleClose();
  // }, [onCloseModalHandler, propertyVerified]);

  // useEffect to show success modal if the question verified successfully
  useEffect(() => {
    if (isByPassOptionAvailable && getObjLength(propertyVerified)) {
      handleResponseModalOpen();
      dispatch(propertiesAction.setVerificationLoader(false));
    }
  }, [dispatch, isByPassOptionAvailable, propertyVerified]);

  useEffect(() => {
    if (!getObjLength(skipVerifyAnswersResponse)) {
      return;
    }

    if (skipVerifyAnswersResponse?.success) {
      completeSkipVerificationFlow();
    }
  }, [skipVerifyAnswersResponse]);
  useEffect(() => {
    if (
      getObjLength(setDefaultOwnerNameDetails) &&
      setDefaultOwnerNameDetails?.success
    ) {
      console.log("setDefaultOwnerNameDetails-->", setDefaultOwnerNameDetails);
      goToOwnerVerification();
      setOwnershipVerificationModal(false);
    }
  }, [setDefaultOwnerNameDetails]);

  return (
    <>
      {isShow && (
        <Typography
          align="center"
          variant="subtitle1"
          className={`py-1 ${isTailwindComponent ? "" : "formHeader"} zoom-container`}
          sx={{
            position: "relative",
            backgroundColor: isTailwindComponent ? "#4ba5dd !important" : "",
            borderRadius: isTailwindComponent ? "6px 6px 0px 0px" : 10,
            color: isTailwindComponent ? "white" : "",
          }}
        >
          <LockIcon sx={{ fontSize: 16 }} className="me-1" />
          Secure connection
          <Button
            onClick={handleCloseAddPropertyModal}
            className="modal-close-btn close-text hide-inner-close"
            style={{
              position: "absolute",
              top: 0,
              right: -16,
              background: "transparent",
              textTransform: "none",
            }}
          >
            <CloseIcon
              className="hide-inner-close"
              sx={{ fontSize: 20, color: "white" }}
            />
          </Button>
        </Typography>
      )}
      {isTailwindComponent ? (
        <div className="tailwind_component">
          <SecurityInfoV2
            initialValues={initialValues}
            validationSchema={activeValidationSchema}
            questions={questions}
            onSubmit={onSubmit}
            setSkipVerificationPopup={updateSkipVerificationPopup}
            skipQuestionAnswers={skipQuestionAnswers}
            isBackToAddPropertyScreen={false}
            isAddPropertyFlow
            addPropertyIntroNote={addPropertyIntroNote}
            buildAddPropertyVerifyPayload={buildAddPropertyVerifyPayload}
            addPropertyEpAwareContext={addPropertyEpAwareContext}
            onPostcardVerificationConfirm={
              !isAdminCreateUser && !isServiceProvider
                ? skipQuestionAnswers
                : undefined
            }
            onAddPropertyIdVerified={handleAddPropertyIdVerified}
            secureConnectionHeader={false}
            isThirdPartyOwnerAttestation={isThirdPartyOwnerAttestation}
            ownershipVerificationAlreadyComplete={
              ownershipVerificationAlreadyComplete
            }
            isServiceProvider={isServiceProvider}
            isAdminCreateUser={isAdminCreateUser}
            backToSearchProperty={backToSearchProperty}
            checked1={checked1}
            setChecked1={setChecked1}
            checkTerms={checkTerms}
            setCheckTerms={setCheckTerms}
            agreeToOwnership={agreeToOwnership}
            setAgreeToOwnership={setAgreeToOwnership}
            category={category}
            isQuestionByPass={isQuestionByPass}
            skipVerification={skipVerification}
            skipVerificationPopupOpen={skipVerificationPopup}
          />
        </div>
      ) : (
        <Formik
          enableReinitialize
          validateOnChange
          initialValues={initialValues}
          validationSchema={activeValidationSchema}
          onSubmit={onSubmit}
          // validateOnBlur
          // validateOnMount
        >
          {({ values, setFieldValue, touched, setTouched, errors }) => {
            return (
              <Form
                id="user-security-info-screen-form"
                className="form-content-spacing"
              >
                {/* Hubspot hidden input for cookie breaker */}
                <HubspotCookieBreakerInput
                  userEmail={userEmail}
                  isPropertyForm={true}
                />

                <Box className="accountBoxWrapper infoForm_Wrapper p-0 p-sm-3">
                  <Typography align="center" variant="h3">
                    Let’s make sure{" "}
                    {role?.includes(ROLES.admin) ||
                    role?.includes(ROLES.subAdmin)
                      ? "the User is the real owner"
                      : "you are the owner"}{" "}
                  </Typography>
                  <Typography align="center" variant="body1">
                    Please answer the following questions about{" "}
                    {role?.includes(ROLES.admin) ||
                    role?.includes(ROLES.subAdmin)
                      ? "User's"
                      : "your"}{" "}
                    property so we are able to identify{" "}
                    {role?.includes(ROLES.admin) ||
                    role?.includes(ROLES.subAdmin)
                      ? "user"
                      : "you"}{" "}
                    as the owner.
                  </Typography>
                  <hr className="formSeparator d-none d-sm-block" />
                  <Typography
                    variant="h4"
                    className="infoTitle pt-3 p-sm-0 px-0 px-sm-2"
                    mb={2}
                  >
                    House information
                  </Typography>

                  <Box pb={3}>
                    <Grid
                      container
                      spacing={2}
                      textAlign={"start"}
                      alignItems={"center"}
                    >
                      {propertyQuestion?.success &&
                        Object.keys(propertyQuestion).length > 0 && (
                          // questions.map((data, key) => (
                          <>
                            {questions[0]?.question && (
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={6}
                                  className="mb-0 mb-lg-3"
                                >
                                  <Typography
                                    variant="body1"
                                    className="infoLabel"
                                  >
                                    {questions[0]?.question}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={6}
                                  className="mb-0 mb-lg-3"
                                >
                                  <FormControl
                                    fullWidth
                                    className="sign-textField"
                                    error={
                                      touched.houseInfo_1 &&
                                      Boolean(errors.houseInfo_1)
                                    }
                                  >
                                    <InputLabel id="demo-simple-select-placeholder">
                                      Select
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-placeholder"
                                      id="houseInfo_1Select"
                                      value={values?.houseInfo_1}
                                      label="select"
                                      name="houseInfo_1"
                                      onChange={(event) => {
                                        setFieldValue(
                                          "houseInfo_1",
                                          event.target.value,
                                        );
                                      }}
                                      MenuProps={MenuProps}
                                    >
                                      {questions[0]?.options?.map((data, i) => (
                                        <MenuItem
                                          value={data !== "" ? data : " "}
                                          sx={{ whiteSpace: "normal" }}
                                        >
                                          {data !== "" ? data : "-"}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    {touched.houseInfo_1 &&
                                      Boolean(errors.houseInfo_1) && (
                                        <FormHelperText
                                          sx={{ color: "#d32f2f" }}
                                        >
                                          {touched.houseInfo_1 &&
                                            errors.houseInfo_1}
                                        </FormHelperText>
                                      )}
                                  </FormControl>
                                </Grid>
                              </>
                            )}
                            {questions[1]?.question && (
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={6}
                                  className="mb-0 mb-lg-3"
                                >
                                  <Typography
                                    variant="body1"
                                    className="infoLabel"
                                  >
                                    {questions[1]?.question}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={6}
                                  className="mb-0 mb-lg-3"
                                >
                                  <FormControl
                                    fullWidth
                                    className="sign-textField"
                                    error={
                                      touched.houseInfo_2 &&
                                      Boolean(errors.houseInfo_2)
                                    }
                                  >
                                    <InputLabel id="demo-simple-select-placeholder">
                                      Select
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-placeholder"
                                      id="houseInfo_2Select"
                                      value={values?.houseInfo_2}
                                      label="select"
                                      name="houseInfo_2"
                                      onChange={(event) => {
                                        setFieldValue(
                                          "houseInfo_2",
                                          event.target.value,
                                        );
                                      }}
                                      MenuProps={MenuProps}
                                    >
                                      {questions[1]?.options?.map((data, i) => (
                                        <MenuItem
                                          value={data !== "" ? data : " "}
                                          sx={{ whiteSpace: "normal" }}
                                        >
                                          {data !== "" ? data : "-"}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    {touched.houseInfo_2 &&
                                      Boolean(errors.houseInfo_2) && (
                                        <FormHelperText
                                          sx={{ color: "#d32f2f" }}
                                        >
                                          {touched.houseInfo_2 &&
                                            errors.houseInfo_2}
                                        </FormHelperText>
                                      )}
                                  </FormControl>
                                </Grid>
                              </>
                            )}
                            {questions[2]?.question && (
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={6}
                                  className="mb-0 mb-lg-3"
                                >
                                  <Typography
                                    variant="body1"
                                    className="infoLabel"
                                  >
                                    {questions[2]?.question}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={6}
                                  className="mb-0 mb-lg-3"
                                >
                                  <FormControl
                                    fullWidth
                                    className="sign-textField"
                                    error={
                                      touched.houseInfo_3 &&
                                      Boolean(errors.houseInfo_3)
                                    }
                                  >
                                    <InputLabel id="demo-simple-select-placeholder">
                                      Select
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-placeholder"
                                      id="houseInfo_3Select"
                                      value={values?.houseInfo_3}
                                      label="select"
                                      name="houseInfo_3"
                                      onChange={(event) => {
                                        setFieldValue(
                                          "houseInfo_3",
                                          event.target.value,
                                        );
                                      }}
                                      MenuProps={MenuProps}
                                    >
                                      {questions[2]?.options?.map((data, i) => (
                                        <MenuItem
                                          value={data !== "" ? data : " "}
                                          sx={{ whiteSpace: "normal" }}
                                        >
                                          {data !== "" ? data : "-"}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    {touched.houseInfo_3 &&
                                      Boolean(errors.houseInfo_3) && (
                                        <FormHelperText
                                          sx={{ color: "#d32f2f" }}
                                        >
                                          {touched.houseInfo_3 &&
                                            errors.houseInfo_3}
                                        </FormHelperText>
                                      )}
                                  </FormControl>
                                </Grid>
                              </>
                            )}
                          </>
                          // ) : (
                          // ))
                        )}
                    </Grid>
                    {!propertyVerified?.success &&
                      propertyVerified?.data?.message && (
                        <p className="text-danger text-center mt-4">
                          {propertyVerified?.data?.message}
                        </p>
                      )}
                  </Box>
                  <div className="text-start">
                    <b>
                      <u>Notes:</u>
                    </b>
                    <ul>
                      <li>
                        County Recorders record all trust, grant deeds, warranty
                        deeds, LLC transfers as a sales/ownership change.
                      </li>
                      <li>
                        The County Recorder lists the full draw of the Home
                        Equity Line of Credit and not the amount utilized at the
                        close of escrow.
                      </li>
                      <li>
                        The original lender is the bank that funded your loan
                        and not the current servicer.
                      </li>
                    </ul>
                  </div>
                  <Box
                    className={!checkTerms && "border border-danger"}
                    textAlign={"start"}
                    py={1}
                    px={2}
                  >
                    <Stack
                      direction={"row"}
                      spacing={1}
                      justifyContent={"flex-start"}
                      alignItems={"start"}
                    >
                      <span className="pt-1">
                        <CustomizedCheckbox onChecked={onChecked} />
                      </span>
                      <span>
                        I agree that an Employee of EquityProtect may call me at
                        any time if they find an issue or an attempt at fraud on
                        my property. I understand that I will be asked challenge
                        questions on that call to verify my identity. If I
                        receive a call and I am not asked the challenge
                        questions, I will hang up and call Customer Support
                        directly.
                      </span>
                    </Stack>
                  </Box>

                  {!checkTerms && (
                    <p className="text-danger mx-0">
                      Please select given terms to proceed further.
                    </p>
                  )}
                  <Box textAlign={"start"} py={1} px={2}>
                    <Stack
                      direction={"row"}
                      spacing={1}
                      justifyContent={"flex-start"}
                      alignItems={"start"}
                    >
                      <span className="pt-1">
                        <CustomizedCheckbox checked />
                      </span>
                      <span>
                        By checking this box I acknowledge that I am the owner
                        of the property above and give EquityProtect permission
                        to verify my ownership.
                      </span>
                    </Stack>
                  </Box>

                  <hr className="formSeparator" />
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={1}
                    justifyContent={"center"}
                    alignItems={"center"}
                    className=" stepBtn px-2 px-sm-5 pb-3"
                  >
                    {role?.includes(ROLES.customer) ||
                    role?.includes(ROLES.professional) ||
                    role?.includes(ROLES.serviceProvider) ||
                    role?.includes(ROLES.secondaryUser) ? (
                      <Button
                        onClick={() => {
                          if (checked1) {
                            updateSkipVerificationPopup(true);
                          } else {
                            setCheckTerms(checked1);
                          }
                        }}
                        className="mx-2 next_button other_popup_btn full_width_btn"
                        variant="contained"
                      >
                        Skip Questions
                      </Button>
                    ) : isUpgradeCategory ? null : (
                      <Button
                        className="mx-2 next_button other_popup_btn"
                        onClick={() => {
                          console.log("New property ads==>");
                          dispatch(propertiesAction.addNewProperty({}));
                          if (
                            propertyQuestion?.data?.from_investor ||
                            getPropertyData?.from_resume
                          ) {
                            backToSearchProperty("propertyList");
                          } else {
                            backToSearchProperty("security");
                          }
                        }}
                      >
                        Back
                      </Button>
                    )}
                    <Button
                      onClick={() => onClickSubmit(errors)}
                      type="submit"
                      className="mx-2 next_button success_popup_btn full_width_btn"
                      // sx={{ padding: "12px 31px !important" }}
                      // variant="contained"
                    >
                      Submit
                    </Button>
                  </Stack>
                </Box>
                {(role?.includes(ROLES.customer) ||
                  role?.includes(ROLES.professional) ||
                  role?.includes(ROLES.serviceProvider)) && (
                  <Button
                    className="mx-2 next_button other_popup_btn"
                    onClick={() => {
                      console.log("New property ads==>");
                      if (role?.includes(ROLES.customer)) {
                        backToSearchProperty("categoryWisePricing");
                      } else if (isServiceProvider && !isAdminCreateUser) {
                        // SP personal add-property: return to category picker
                        backToSearchProperty("categoryWisePricing");
                      } else {
                        dispatch(propertiesAction.addNewProperty({}));
                        backToSearchProperty("security");
                      }
                    }}
                  >
                    Back
                  </Button>
                )}
              </Form>
            );
          }}
        </Formik>
      )}

      <Loader
        open={
          (verificationLoader || ownerShipLoader || signupLoader) &&
          !isResponseModalOpen &&
          !ownershipVerificationModal &&
          !skipVerificationPopup
        }
      />

      {getObjLength(skipVerifyAnswersResponse) &&
      !skipVerifyAnswersResponse?.success ? (
        <AlertDialog
          isTailwindComponent={isTailwindComponent}
          type="Error"
          openPopup={true}
          onClose={true}
          onCloseFun={() => {
            dispatch(userSigupAction.clearSkipVerifyAnswers({}));
          }}
          mesage={
            skipVerifyAnswersResponse?.data?.message ||
            skipVerifyAnswersResponse?.message ||
            "Unable to skip property verification."
          }
          footer={false}
        />
      ) : null}

      {isResponseModalOpen && getObjLength(propertyVerified) && (
        <>
          {getObjLength(propertyVerified) && propertyVerified?.success ? (
            <AlertDialog
              isTailwindComponent={isTailwindComponent}
              type="Success"
              openPopup={isResponseModalOpen}
              onClose={true}
              onCloseFun={handleVerifiedSuccessModalClose}
              mesage={propertyVerified?.message}
              footer={false}
            />
          ) : (
            // <AlertDialog
            //   type="Error"
            //   openPopup={isResponseModalOpen}
            //   onClose={true}
            //   onCloseFun={() => {
            //     handleResponseModalClose();
            //   }}
            //   mesage={propertyVerified?.data?.message}
            //   footer={false}
            // />
            <AlertDialog
              isTailwindComponent={isTailwindComponent}
              type="Error"
              openPopup={isResponseModalOpen}
              onClose={false}
              mesage={
                <>
                  <b>{propertyVerified?.data?.message}</b>
                  {parseInt(verifiedCount) < 3 && (
                    <p className="pt-1">
                      You've {numberToWords(3 - parseInt(verifiedCount))} more{" "}
                      {3 - parseInt(verifiedCount) === 1 ? "chance" : "chances"}{" "}
                      to choose correct answers or else you can Find Property
                      again.
                    </p>
                  )}
                </>
              }
              buttons={
                <>
                  {parseInt(verifiedCount) < 3 ? (
                    <Button
                      className={`popup_Btn m-2 ${isUpgradeCategory ? "error_popup_btn" : "other_popup_btn"}`}
                      onClick={() => {
                        setVerifiedCount(parseInt(verifiedCount) + 1);
                        setIsResponseModalOpen(false);
                        dispatch(propertiesAction.clearVerifedAnswersData({}));
                      }}
                    >
                      Try Again ({3 - parseInt(verifiedCount)})
                    </Button>
                  ) : isUpgradeCategory ? (
                    <Button
                      className="popup_Btn error_popup_btn"
                      onClick={() => {
                        handleCloseAddPropertyModal();
                      }}
                    >
                      Close
                    </Button>
                  ) : null}
                  {!isUpgradeCategory && (
                    <Button
                      className="popup_Btn error_popup_btn"
                      onClick={() => {
                        console.log("New property ads==>");
                        dispatch(propertiesAction.addNewProperty({}));
                        backToSearchProperty("security");
                      }}
                    >
                      Find Property again.
                    </Button>
                  )}
                </>
              }
            />
          )}
        </>
      )}

      {skipVerificationPopup &&
        (isTailwindComponent ? (
          <StatusModal
            open={skipVerificationPopup}
            onOpenChange={updateSkipVerificationPopup}
            variant="info"
            title="Info"
            message="Do you want to skip the Property Verification process?"
            secondaryButtonLabel="No"
            onSecondaryAction={() => updateSkipVerificationPopup(false)}
            primaryButtonLabel="Yes"
            onPrimaryAction={skipQuestionAnswers}
          />
        ) : (
          <AlertDialog
            type="Info"
            openPopup={skipVerificationPopup}
            onClose={true}
            onCloseFun={() => updateSkipVerificationPopup(false)}
            mesage={"Do you want to skip the Property Verification process?"}
            footer={false}
            buttons={
              <>
                <Button
                  type="button"
                  className="popup_Btn other_popup_btn mx-2"
                  onClick={() => updateSkipVerificationPopup(false)}
                >
                  No
                </Button>
                <Button
                  type="button"
                  className="popup_Btn success_popup_btn mx-2"
                  onClick={skipQuestionAnswers}
                >
                  Yes
                </Button>
              </>
            }
          />
        ))}

      {ownershipVerificationModal && (
        <OwnershipVerificationModal
          isTailwindComponent={isTailwindComponent}
          ownershipVerificationModal={ownershipVerificationModal}
          goToNextStep={goToOwnerVerification}
          property_id={getPropertyData?.property_id}
          proeprty_data={getPropertyData}
          OwnerName={
            user_data?.first_owner_first_name || user_data?.first_trust_llc_name
          }
        />
      )}
    </>
  );
};

export default SecurityInfoScreen;
